:host {
  /* Not convinced we need these two but keeping them (undocumented) for now */
  --menu-dropdown-z-index: 1;
  --mobile-menu-z-index: 1;

  font-family: var(--pdt-font-family-brand, sans-serif);
  position: relative;
  z-index: var(--eco-suite-navbar-z-index, 2);

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

.EcoSuiteNavbar {
  --navbar-height: 48px;
  --mobile-search-height: 64px;

  /* Temporary fix: provide only the necessary V2 design tokens for the pwc-icon-button to avoid pulling in the entire PWC stylesheet */
  --core-color-blue-800: var(--pdt-color-border-focused);
  --core-color-monochrome-300: var(--pdt-color-border-subtle);
  --core-color-monochrome-700: var(--pdt-color-text-bold);

  width: 100%;
  height: var(--navbar-height);
  padding-block: 0;
  padding-inline: var(--pdt-space-100) var(--pdt-space-150);
  position: fixed;
  top: 0;
  inset-inline: 0;
  background-color: var(--pdt-color-surface);
  border-bottom: 1px solid var(--pdt-color-border-subtle);
  transition: height .2s ease;

  /* Hide elements while we wait for the navbarContext to recalculate */
  .hideOnMobile {
    @media (width < 480px) {
      display: none;
    }
  }

  &--static {
    position: relative;
  }

  &--searchBarExpanded {
    height: calc(var(--navbar-height) + var(--mobile-search-height));
  }

  &__row {
    display: flex;
    align-items: center;
    gap: var(--pdt-space-100);
    height: var(--navbar-height);
  }

  &__left,
  &__right {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__left {
    justify-content: flex-start;
    gap: var(--pdt-space-100);
  }

  &__right {
    flex-grow: 1;
    justify-content: flex-end;
    gap: var(--pdt-space-50);

    slot[name="utilities"] {
      align-items: center;
      gap: var(--pdt-space-50);
      min-width: 0;
    }
  }

  &__homeTooltip {
    min-width: 0;
  }

  &__homeLink {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--pdt-space-100);
    cursor: pointer;
    opacity: 1;
    border: 1px solid transparent;
    text-decoration: none;
    color: var(--pdt-color-text);
    font-size: var(--pdt-font-size-sm);
    font-weight: var(--pdt-font-weight-medium);
    transition: opacity .2s ease;
    padding: 0 var(--pdt-space-50);
    border-radius: var(--pdt-radius-75);
    user-select: none;

    &:hover {
      opacity: .75;
    }

    &:active {
      opacity: 1;
    }

    &:focus-visible {
      outline: 0;
      border-color: var(--pdt-color-border-focused);
      box-shadow: var(--pdt-shadow-focus);
    }

    img {
      max-height: 36px;
      min-height: 24px;
      min-width: 24px;
      max-width: 100px;
      display: none;

      @media (width >= 480px) {
        display: block;
      }
    }

    &--defaultLogo {
      img {
        width: 28px;
        height: 28px;
      }
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__search {
    display: flex;
    align-items: center;
    transition: all .2s ease;

    @media (width >= 768px) and (width <= 1024px) {
      &--hasSearch {
        width: 200px;
        max-width: 200px;
      }

      &--expanded {
        width: 100%;
        max-width: 500px;
      }
    }

    @media (width >= 1024px) {
      width: 100%;
      max-width: 500px;
      margin-right: var(--pdt-space-50);
    }
  }

  &__searchBarToggle {
    @media (width >= 768px) {
      display: none;
    }
  }

  &__searchBar {
    display: flex;
    align-items: center;
    gap: var(--pdt-space-100);
    width: 100%;
    height: var(--mobile-search-height);
    padding: 0 var(--pdt-space-200);
    opacity: 0;
    pointer-events: none;

    &--expanded {
      padding: 0 var(--pdt-space-50);
      opacity: 1;
      pointer-events: auto;
      transition: opacity .2s ease;
      transition-delay: .1s;
    }
  }

  &__searchBarClose,
  &__mobileToggle {
    @media (width >= 480px) {
      display: none;
    }
  }
}
